import { Icon, theme } from '@ketch-com/deck'
import { Box, Tooltip, TooltipProps } from '@mui/material'
import React from 'react'

export interface InfoIconWithTooltipProps {
  title: TooltipProps['title']
}

export const InfoIconWithTooltip: React.FC<InfoIconWithTooltipProps> = ({ title }) => {
  return (
    <Tooltip title={title}>
      <Box component="span" display="flex" alignItems="center" sx={{ cursor: 'pointer' }}>
        <Icon name="FUnknown" iconColor={theme.palette.Black.o48} width={16} height={16} />
      </Box>
    </Tooltip>
  )
}
